import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { AppProvider } from './context/AppContext';
import { AuthProvider } from './context/AuthContext';
import Routes from './routes';
import { BrowserRouter } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { ConfirmProvider } from 'material-ui-confirm';
import { green } from '@mui/material/colors';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import setDefaultOptions from 'date-fns/setDefaultOptions'
import ptBR from 'date-fns/locale/pt-BR';
import { CookiesProvider } from 'react-cookie';
import AvisoDeCookies from './components/AvisoDeCookies';

setDefaultOptions({
    locale: ptBR
})
const myTheme = createTheme({
    palette: {
        primary: {
            main: '#006A61',
        },
    },
});

// Object.assign(myTheme, {

//     overrides: {
//         MUIRichTextEditor: {
//             root: {
//                 border: '1px solid #ccc',
//                 borderRadius: '4px',
//             },
//             editor: {
//                 borderTop: '1px solid #ccc',
//                 paddingLeft: '30px',
//             },
//             placeHolder: {
//                 fontSize: '16px',
//                 paddingLeft: '20px',
//                 position: 'inherit',
//             },
//         },
//     },
// });

function App() {
    return (
        <CookiesProvider >
            <ThemeProvider theme={myTheme}>
                <BrowserRouter basename="/">
                        {/* adapterLocale e obrigatorio: sem ele os campos de data
                            ficam em formato americano (MM/DD/YYYY e hora em 12h com
                            AM/PM), o que impede digitar dia 12 ou hora 14:30.
                            setDefaultOptions do date-fns nao alcanca o adapter. */}
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                            <AppProvider>
                                <AuthProvider>
                                    <ConfirmProvider>
                                        <Routes />
                                        {/* Fora do Routes de proposito: o aviso
                                            vale para qualquer tela, inclusive as
                                            publicas */}
                                        <AvisoDeCookies />
                                    </ConfirmProvider>
                                </AuthProvider>
                            </AppProvider>
                        </LocalizationProvider>
                </BrowserRouter>
            </ThemeProvider>
        </CookiesProvider>
    );
}

export default App;
